"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var isObject = function isObject(val) {
  return (0, _typeof2.default)(val) === 'object' && val !== null && !Array.isArray(val);
};
exports.isObject = isObject;